export default __webpack_public_path__ + "images/ab05573aad524a8dd9ea8417c2ea6b26-connect-texto.svg";